<template>
	<el-header class="admin-header" :style="{'padding-left':topNav?'0px':'240px'}" height="60px" >
		<div class="header-menu" v-cloak>
			<p style="line-height: 55px;padding-left: 25px;color: #000000;font-size: 20px;font-weight: bold" v-text="$t('label_595')">
<!--				<i :class="isCollapse ?'el-icon-s-unfold':'el-icon-s-fold' " @click="togleCollapse"-->
<!--					style="cursor : pointer;"></i>-->
			</p>
		</div>
		<div class="header-user">
			<div @click="seeShare" v-if="version==1" style="padding-right: 10px;cursor: pointer">分享</div>
			<div style="padding-right: 20px">{{timeText}}</div>
			<!-- <div v-if="version!=3" class="user-info" @click="dialogVisible=true" style="cursor:pointer;">
				欢迎您，{{$store.getters.getUserName}}
			</div>
			<div v-else class="user-info" style="cursor:pointer;">
				欢迎您，{{$store.getters.getUserName}}
			</div> -->
			<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
				<span class="el-dropdown-link" style="cursor:pointer;">
					{{$t('label_598')}}，{{$store.getters.getUserName}}<i class="el-icon-arrow-down el-icon--right"></i>
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-if="version!=3" @click.native="dialogVisible = true">
						<span>{{$t('label_610')}}</span>
					</el-dropdown-item>
					<el-dropdown-item v-else>
						<span>{{$t('label_610')}}</span>
					</el-dropdown-item>
					<el-dropdown-item @click.native="setting = true">
						<span>{{$t('label_614')}}</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>

			<div class="user-logout" v-if="version!=3">
				<img src="" height="20">
				<span @click="loginOut" style="cursor:pointer;">
					{{$t('label_601')}}
				</span>
			</div>
		</div>
		<el-dialog v-loading="saveLoading" :title="$t('label_610')" :close-on-click-modal='false' :visible.sync="dialogVisible" width="30%"
			:append-to-body="true" center>
			<el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
				<el-form-item :label="$t('label_626')" prop="fullName" label-width="140px">
					<el-input v-model="editForm.oldPass"></el-input>
				</el-form-item>
				<el-form-item :label="$t('label_630')" prop="userName" label-width="140px">
					<el-input v-model="editForm.newPass"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="edit">{{$t('btn_13')}}</el-button>
			</span>
		</el-dialog>
		<el-drawer v-loading="saveLoading" size="280px" :visible.sync="setting" :with-header="false" :append-to-body="true" :show-close="false"
			ref="drawer">
			<div class="drawer-container">
				<div>
					<div class="setting-drawer-content">
						<!-- <div class="setting-drawer-title">
							<h3 class="drawer-title">主题风格设置</h3>
						</div>
						<div class="setting-drawer-block-checbox">
							<div class="setting-drawer-block-checbox-item" @click="handleTheme('theme-dark')">
								<img src="@/assets/images/dark.svg" alt="dark">
								<div v-if="sideTheme === 'theme-dark'" class="setting-drawer-block-checbox-selectIcon"
									style="display: block;">
									<i aria-label="图标: check" class="anticon anticon-check">
										<svg viewBox="64 64 896 896" data-icon="check" width="1em" height="1em"
											:fill="theme" aria-hidden="true" focusable="false" class="">
											<path
												d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" />
										</svg>
									</i>
								</div>
							</div>
							<div class="setting-drawer-block-checbox-item" @click="handleTheme('theme-light')">
								<img src="@/assets/images/light.svg" alt="light">
								<div v-if="sideTheme === 'theme-light'" class="setting-drawer-block-checbox-selectIcon"
									style="display: block;">
									<i aria-label="图标: check" class="anticon anticon-check">
										<svg viewBox="64 64 896 896" data-icon="check" width="1em" height="1em"
											:fill="theme" aria-hidden="true" focusable="false" class="">
											<path
												d="M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" />
										</svg>
									</i>
								</div>
							</div>
						</div> -->

						<div class="drawer-item">
							<span>{{$t('label_618')}}</span>
							<theme-picker style="float: right;height: 26px;margin: -3px 8px 0 0;"
								@change="themeChange" />
						</div>
					</div>

					<el-divider />

					<h3 class="drawer-title">{{$t('label_614')}}</h3>

					<div class="drawer-item">
						<span>{{$t('label_622')}} TopNav</span>{{$t('label_168')}}
						<el-switch v-model="topNav" class="drawer-switch" />
					</div>

					<!-- <div class="drawer-item">
						<span>开启 Tags-Views</span>
						<el-switch v-model="tagsView" class="drawer-switch" />
					</div>

					<div class="drawer-item">
						<span>固定 Header</span>
						<el-switch v-model="fixedHeader" class="drawer-switch" />
					</div>

					<div class="drawer-item">
						<span>显示 Logo</span>
						<el-switch v-model="sidebarLogo" class="drawer-switch" />
					</div>

					<div class="drawer-item">
						<span>动态标题</span>
						<el-switch v-model="dynamicTitle" class="drawer-switch" />
					</div> -->

					<el-divider />

					<el-button size="small" type="primary" plain icon="el-icon-document-add"
						@click="saveSetting">{{$t('btn_13')}}</el-button>
					<el-button size="small" plain icon="el-icon-refresh" @click="resetSetting">{{$t('label_95')}}</el-button>
				</div>
			</div>
		</el-drawer>
	</el-header>
</template>

<script>
	import CommonJs from '@/assets/js/common/common.js'
	import utils from "@/utils/utils";
	import store from '@/store'
	import Request from "@/assets/js/request/request.js";
	import $ from 'jquery'
	import Utils from '@/assets/js/signal/util.js'
	import Vue from "vue";
	import global from "../../assets/js/common/common";
	import {
		mapGetters
	} from 'vuex';
	import ThemePicker from '@/components/ThemePicker';
	import {
		Message,
		MessageBox,
		Notification,
		Loading
	} from 'element-ui'
  import { setLanguage} from "../../main";

	export default {
		name: 'AdminHeader',
		components: {
			ThemePicker
		},
		data() {
			return {
        saveLoading: false,
				isCollapse: false,
				path: "",
				loading: false,
				zoom: 100,
				timeText: "",
				userId: "",
				dialogVisible: false,
				editForm: {
					oldPass: '',
					newPass: '',
				},
				rules: {
					oldPass: [{
						required: true,
						message: this.$t('input_114'),
						trigger: 'blur'
					}],
					newPass: [{
						required: true,
						message: this.$t('input_115'),
						trigger: 'blur'
					}]
				},
				socket: "",
				version: "",
				setting: false,
				theme: this.$store.state.settings.theme,
				sideTheme: this.$store.state.settings.sideTheme,
			}
		},
		computed: {
			...mapGetters([
				'sidebar',
				'avatar',
				'device'
			]),
			visible: {
				get() {
					return this.$store.state.settings.showSettings
				}
			},
			fixedHeader: {
				get() {
					return this.$store.state.settings.fixedHeader
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'fixedHeader',
						value: val
					})
				}
			},
			topNav: {
				get() {
					console.log(this.$store.state.settings.topNav)
					return this.$store.state.settings.topNav
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'topNav',
						value: val
					})
				}
			},
			tagsView: {
				get() {
					return this.$store.state.settings.tagsView
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'tagsView',
						value: val
					})
				}
			},
			sidebarLogo: {
				get() {
					return this.$store.state.settings.sidebarLogo
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'sidebarLogo',
						value: val
					})
				}
			},
			dynamicTitle: {
				get() {
					return this.$store.state.settings.dynamicTitle
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'dynamicTitle',
						value: val
					})
				}
			},
		},
    beforeCreate() {
      const lang = store.getters.getLanguageName;
      if (lang=="1") {
        setLanguage("chs")
      } else if (lang=="2") {
        setLanguage("ja")
      } else if (lang=="3") {
        setLanguage("en")
      }
    },
    created() {
			var that = this;
			if (sessionStorage.getItem('store')) {
				this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
			}
			/*setTimeout(function () {
			  var socketUrl = store.getters.getPostUrl;
			  socketUrl = socketUrl.replace("https", "ws").replace("http", "ws");
			  that.path = socketUrl+'/ws/asset';
			  that.init();
			}, 1000)*/
		},
		mounted() {
			// 初始化
      // const lang = store.getters.getLanguageName;
      // if (lang=="1"){
      //   loadLanguageAsync('chs')
      // }
      // if (lang=="2"){
      //   loadLanguageAsync('ja')
      // }
      // if (lang=="3"){
      //   loadLanguageAsync('en')
      // }
			this.version = this.$store.getters.getVersions;
			this.getTimeText();
			this.userId = this.$store.getters.getCurrentUser.userId;
			if (sessionStorage.getItem('store')) {
				this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
			}

      Vue.prototype.$("#loader-wrapper").hide();
		},
		methods: {
			seeShare() {
				window.open(window.location.href, '_blank');

			},
			togleCollapse() {
				this.isCollapse = !this.isCollapse;
				if (this.isCollapse) {
					$(".el-aside.admin-aside").css('width', '0px')
					$(".el-main.admin-main").css('padding', '60px 0 0 0px')
					$(".admin-container .admin-header").css('padding-left', '10px')
					$(".style_all_s").css('justify-content', 'flex-start')
					$(".box_down_rigth").css('width', '39%')
					$(".box_down_left").css('width', '39%')
					if (this.$store.state.ActiveMenu.indexOf("quipmentMonitoring") != -1) {
						test2(240)
					} else {
						test3()
						test(45)
					}
				} else {
					$(".el-aside.admin-aside").css('width', '240px')
					$(".el-main.admin-main").css('padding', topNav ? '60px 0 0 0px' : '60px 0 0 240px');
					$(".admin-container .admin-header").css('padding-left', topNav ? '10px' : '240px');
					$(".style_all_s").css('justify-content', ' space-between')
					$(".box_down_rigth").css('width', '37%')
					$(".box_down_left").css('width', '37%')
					if (this.$store.state.ActiveMenu.indexOf("quipmentMonitoring") != -1) {
						test2(-240)
					} else {
						test3()
						test(40)
					}
				}
			},
			loginOut() {
				Request.LoginOut().then((response) => {
					sessionStorage.clear();
					this.$router.push({
						path: '/static/login'
					});
				}).catch((response) => {
					console.log(response)
				})
			},
			getTimeText() {
				let that = this;
				// utils.timing(function() {
				// 	that.timeText = utils.getNowFormatDate();
				// }, 1000, 'timing');
				setInterval(() => {
					that.timeText = utils.getNowFormatDate();
				}, 1000);
			},
			edit() {
        this.saveLoading = true;
				if (this.editForm.oldPass == "") {
					utils.messageAlert(this.$t('input_49') + this.$t('label_626'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return
				}
				if (this.editForm.newPass == "") {
					utils.messageAlert(this.$t('input_49') + this.$t('label_630'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return
				}
				Request.changePassword(this.userId, this.editForm).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.$router.push({
							path: '/static/login'
						});
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
          this.saveLoading = false;
				}).catch((response) => {
					console.log(response)
          this.saveLoading = false;
				})
			},
			themeChange(val) {
				this.$store.dispatch('settings/changeSetting', {
					key: 'theme',
					value: val
				})
				this.theme = val;
			},
			handleTheme(val) {
				this.$store.dispatch('settings/changeSetting', {
					key: 'sideTheme',
					value: val
				})
				this.sideTheme = val;
			},
			saveSetting() {
        this.saveLoading = true;
				// this.$modal.loading("正在保存到本地，请稍候...");
				let loadingInstance = Loading.service({
					lock: true,
					text: this.$t('msg_224'),
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)",
				});

				localStorage.setItem(
					"layout-setting",
					`{
			  "topNav":${this.topNav},
			  "tagsView":${this.tagsView},
			  "fixedHeader":${this.fixedHeader},
			  "sidebarLogo":${this.sidebarLogo},
			  "dynamicTitle":${this.dynamicTitle},
			  "sideTheme":"${this.sideTheme}",
			  "theme":"${this.theme}"
			}`
				);
        this.saveLoading = false;
				setTimeout(() => {
					loadingInstance.close();
				}, 1000);
				this.$refs.drawer.closeDrawer();
			},
			resetSetting() {
				// this.$modal.loading("正在清除设置缓存并刷新，请稍候...");
				let loadingInstance = Loading.service({
					lock: true,
					text: "正在清除设置缓存并刷新，请稍候...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)",
				});
				// this.$cache.local.remove("layout-setting")
				localStorage.removeItem("layout-setting");
				setTimeout(() => {
					loadingInstance.close();
				}, 1000);
				this.$refs.drawer.closeDrawer();
				setTimeout("window.location.reload()", 1000)
			}
		},
		destroyed() {
			utils.clearTime('timing');
			// 销毁监听
			//this.socket.onclose = this.close
		}
	}
</script>
<style lang="css">
  [v-cloak] {
    display: none !important;
  }
	.setting-drawer-content .setting-drawer-title {
		margin-bottom: 12px;
		color: rgba(0, 0, 0, 0.85);
		font-size: 14px;
		line-height: 22px;
		font-weight: bold;
	}

	.setting-drawer-content .setting-drawer-block-checbox {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-top: 10px;
		margin-bottom: 20px;
	}

	.setting-drawer-content .setting-drawer-block-checbox .setting-drawer-block-checbox-item {
		position: relative;
		margin-right: 16px;
		border-radius: 2px;
		cursor: pointer;
	}

	.setting-drawer-content .setting-drawer-block-checbox .setting-drawer-block-checbox-item img {
		width: 48px;
		height: 48px;
	}

	.setting-drawer-content .setting-drawer-block-checbox .setting-drawer-block-checbox-item .setting-drawer-block-checbox-selectIcon {
		position: absolute;
		top: 0;
		right: 0;
		width: 100%;
		height: 100%;
		padding-top: 15px;
		padding-left: 24px;
		color: #1890ff;
		font-weight: 700;
		font-size: 14px;
	}

	.drawer-container {
		padding: 20px;
		font-size: 14px;
		line-height: 1.5;
		word-wrap: break-word;
	}

	.drawer-container .drawer-title {
		margin-bottom: 12px;
		color: rgba(0, 0, 0, 0.85);
		font-size: 14px;
		line-height: 22px;
	}

	.drawer-container .drawer-item {
		color: rgba(0, 0, 0, 0.65);
		font-size: 14px;
		padding: 12px 0;
	}

	.drawer-container .drawer-switch {
		float: right;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue